'use client'
import {providerMap} from '@/auth';
import GoogleLoginButton from '@/components/LoginGoogleButton';
import LinkedInLoginButton from '@/components/LoginLinkedInButton';
import React from 'react';
import {handleLogin} from '@/lib/handle-login-logout';
import { useSearchParams } from 'next/navigation'
import EidrLogo from "@/assets/eidr-d.svg";
const LoginInWithButton = ({provider}) => {
    switch (provider.name) {
        case 'Google':
            return <GoogleLoginButton provider={provider}></GoogleLoginButton>;
        case 'LinkedIn':
            return <LinkedInLoginButton provider={provider}></LinkedInLoginButton>;
    }
};

export default function ({props}) {

    let params = useSearchParams()
    let redirect = params.get('redirect')

    // @ts-ignore
    return (
        <div className="flex flex-column grow items-center w-full justify-center ">
            <div className="w-full mx-2 md:mx-0">
                <div className="flex flex-col gap-2 ">
                    {Object.values(providerMap).map((provider, index) => (
                        <form action={handleLogin} key={'provider-' + index} data-provider={provider.id}>
                            <input type="hidden" name="provider" value={provider.id}/>
                            { redirect && <input type="hidden" name="redirect" value={redirect}/> }
                            <LoginInWithButton
                                provider={provider}
                                key={'provider-' + index}
                            />
                        </form>
                    ))}
                    <a className="flex flex-row justify-between items-center shadow-sm p-2 w-full mb-2 cursor-pointer text-white rounded bg-blue-500 hover:bg-blue-600 "
                    href="/auth/signin/eidr">
                        <div className="flex flex-row items-center">
                            <img
                                src={EidrLogo.src}
                                alt="EidrLogo"
                                width="35px"
                                height="35px"
                            />
                            <div className={'ms-3'}>Log in with EIDR</div>
                        </div>
                        <i className="mio">arrow_forward_ios</i>
                    </a>
                </div>
            </div>
        </div>
    );
}
